import { Modal, TextInput } from 'maeng-daisyui'
import React, { ChangeEvent, Fragment, forwardRef, useCallback } from 'react'
import { Link } from 'gatsby'
import { useQueryPost } from '@/hooks/useQueryPost'

const SearchModal = forwardRef<HTMLDialogElement>((props, ref) => {
  const { search, onChange, data } = useQueryPost()

  const handleChangeKeyword = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value)
    },
    [onChange],
  )

  const isMountedModal = typeof ref !== 'function' && ref?.current

  const handleCloseModal = useCallback(() => {
    if (isMountedModal) {
      onChange('')
      ref.current?.close()
    }
  }, [isMountedModal, onChange, ref])

  return (
    <Modal
      ref={ref}
      position="top"
      title={<h3 className="font-bold text-lg">Quick Search</h3>}
      onClose={handleCloseModal}
      content={
        <div className="py-4">
          <TextInput
            bordered
            placeholder="검색어를 입력해주세요."
            value={search}
            onChange={handleChangeKeyword}
          />
          {data.length > 0 && (
            <>
              <div className="divider mb-1" />
              <ul className="max-h-[400px] overflow-auto">
                {data.map(({ id, title, excerpt, slug }, idx) => (
                  <Fragment key={id}>
                    {idx !== 0 && <div className="divider my-1" />}
                    <Link
                      className="block p-2 opacity-70 hover:bg-blue-50 hover:opacity-100 hover:rounded-md"
                      to={slug}
                      onClick={handleCloseModal}
                    >
                      <li>
                        <h4 className="font-semibold mb-2">{title}</h4>
                        <p className="text-sm text-gray-500 line-clamp-2">{excerpt}</p>
                      </li>
                    </Link>
                  </Fragment>
                ))}
              </ul>
            </>
          )}
        </div>
      }
      closeButton
      {...props}
    />
  )
})

export default SearchModal
